import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const deleteImagesStatusSelector = (state: State) =>
  state.deleteImagesSurvey.status;
export const deleteImagesIdSelector = (state: State) =>
  state.deleteImagesSurvey.entities;
export const deleteImagesLoadedSelector = isLoaded(deleteImagesStatusSelector);
export const shouldLoadDeleteImagesSelector = shouldLoad(
  deleteImagesStatusSelector,
);
export const deleteImagesRejectedSelector = isRejected(
  deleteImagesStatusSelector,
);
export const deleteImagesPendingSelector = isPending(
  deleteImagesStatusSelector,
);
